import * as tslib_1 from "tslib";
import * as React from 'react';
import { fullWidthClassName, zeroRightClassName } from 'react-remove-scroll-bar/constants';
import { effectCar } from "./medium";

var nothing = function nothing() {
  return;
};

function RemoveScroll(props) {
  var ref = React.useRef(null);

  var _a = React.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }),
      callbacks = _a[0],
      setCallbacks = _a[1];

  var forwardProps = props.forwardProps,
      children = props.children,
      className = props.className,
      removeScrollBar = props.removeScrollBar,
      enabled = props.enabled,
      shards = props.shards,
      sideCar = props.sideCar,
      noIsolation = props.noIsolation,
      inert = props.inert;
  var SideCar = sideCar;

  var containerProps = tslib_1.__assign({
    ref: ref
  }, callbacks);

  return React.createElement(React.Fragment, null, enabled && React.createElement(SideCar, {
    sideCar: effectCar,
    removeScrollBar: removeScrollBar,
    shards: shards,
    noIsolation: noIsolation,
    inert: inert,
    setCallbacks: setCallbacks,
    lockRef: ref
  }), forwardProps ? React.cloneElement(React.Children.only(children), containerProps) : React.createElement("div", tslib_1.__assign({}, containerProps, {
    className: className
  }), children));
}

RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};

(function (RemoveScroll) {
  RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName
  };
})(RemoveScroll || (RemoveScroll = {}));

export { RemoveScroll };